export default __webpack_public_path__ + "static/media/Alexanderplatz.2b1889a5.jpg";